export function FirebaseTimestampToDate(timestamp: any): Date {
    return new Date(timestamp.seconds * 1000);
}
